import { ContactCards } from "@/components/support/ContactCards";

const Contact = () => {
  return (
    <div className="container mx-auto min-w-0 max-w-4xl px-4 py-8 pb-16">
      <ContactCards />
    </div>
  );
};

export default Contact;
